import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, y = 28, className = "", ...rest }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, delay, ease: EASE }}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

export function FadeIn({ children, delay = 0, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: 18 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.8, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

// Signature masked line-by-line reveal. Lines accept JSX so a single headline
// can hold responsive breaks (e.g. <br className="lg:hidden" />) — one element in the DOM.
export function MaskLines({ lines, className = "", lineClassName = "", delay = 0, stagger = 0.14, testId = "masked-headline" }) {
  return (
    <motion.h1 className={className} initial="hidden" animate="show" data-testid={testId}>
      {lines.map((l, i) => (
        <span key={i} className="block overflow-hidden pb-[0.06em] -mb-[0.06em]">
          <motion.span
            className={`block will-change-transform ${lineClassName}`}
            variants={{ hidden: { y: "115%", rotate: 2.5 }, show: { y: "0%", rotate: 0 } }}
            transition={{ duration: 1.15, delay: delay + i * stagger, ease: EASE }}
          >
            {l}
          </motion.span>
        </span>
      ))}
    </motion.h1>
  );
}
